import './AuthBanner.scss';

const AuthBanner = () => {

    return (
        <div className={"login-banner"}>
            <div className={"login-banner_container"}>

            </div>
        </div>
    )
}

export default AuthBanner;